
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 19H2.643C1.735 19 1 18.105 1 17V3c0-1.105.735-2 1.643-2H13.32c.908 0 1.643.895 1.643 2v6.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M9.054 16.215a.454.454 0 010-.43c.871-1.611 2.48-3.007 4.089-3.007 1.609 0 3.217 1.396 4.088 3.007a.455.455 0 010 .43c-.87 1.611-2.48 3.007-4.088 3.007-1.609 0-3.218-1.396-4.089-3.007z","stroke":"#363636","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.12 15.024a1.381 1.381 0 11-1.954 1.953 1.381 1.381 0 011.953-1.954z","fill":"#3084B9"}}),_c('path',{attrs:{"stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.75 5.25h4.5"}}),_c('path',{attrs:{"d":"M7.734 9.676l-.241.53h-3.3l.197-.53h3.344zm-.46 1.027l-.256.537H4.194l.196-.537h2.884zM8.36 8.322l-.348.74a2.408 2.408 0 00-.27-.183 1.674 1.674 0 00-.336-.15 1.3 1.3 0 00-.403-.06 1.12 1.12 0 00-.654.197c-.189.13-.337.327-.445.592-.106.263-.159.597-.159 1.002 0 .404.053.738.16 1.001.107.264.255.46.444.587.189.127.407.191.654.191.146 0 .28-.019.403-.057.122-.038.232-.086.33-.144.1-.058.185-.116.256-.174l.353.74c-.177.155-.382.27-.614.349-.23.078-.473.117-.728.117-.424 0-.8-.104-1.129-.311a2.113 2.113 0 01-.768-.898c-.185-.39-.278-.858-.278-1.402 0-.545.093-1.013.278-1.404a2.11 2.11 0 01.768-.9c.328-.21.705-.316 1.129-.316a2.1 2.1 0 011.357.483z","fill":"#363636"}})])
          )
        }
      }
    